import React from "react";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import ReferralHash from "../../../common/referral-hash";

import parlor from "../../../assets/graphics/icons/parlor.svg";
import apple from "assets/graphics/icons/apple--white.svg";
import android from "assets/graphics/icons/android--white.svg";

import "screens/activations/component/view.scss";

const ActivationsView = () => (
  <main className="activations">
    <nav className="activations__header">
      <Link
        to={
          "/" + (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        }
      >
        <img className="activations__logo" src={parlor} alt="parlor" />
      </Link>
    </nav>
    <div className="activations__container">
      <h1 className="application__headline activations__headline">
        Download the app
      </h1>
      <p className="form__description--large activations__description">
        For now access to member portal is only possible through our mobile app.
      </p>
      {isMobile && (
        <div className="activations__stores">
          <a
            className="activations__store"
            href="https://apps.apple.com/us/app/parlor-social-club/id1473428896"
            target="blank"
            onClick={() => window.dataLayer.push({ event: "iosVisited" })}
          >
            <img src={apple} alt="apple" />
          </a>
          <a
            className="activations__store"
            href="https://play.google.com/store/apps/details?id=social.parlor.app"
            target="blank"
            onClick={() => window.dataLayer.push({ event: "androidVisited" })}
          >
            <img src={android} alt="android" />
          </a>
        </div>
      )}
    </div>
  </main>
);

export default ActivationsView;
